import classNames from 'classnames';
import { useCallback } from 'react';
import IconRenderer from '@alltrails/denali/components/IconRenderer';
import BikingMtn from '@alltrails/denali/icons/BikingMtn';
import BikingRoad from '@alltrails/denali/icons/BikingRoad';
import Hiking from '@alltrails/denali/icons/Hiking';
import Running from '@alltrails/denali/icons/Running';
import { HeatmapActivityIcon, HeatmapActivityOption } from '../../types/HeatmapActivity';
import { HeatmapTimeRangeOption } from '../../types/HeatmapTimeRange';
import styles from './OptionChip.module.scss';

const getIcon = (activity: HeatmapActivityIcon) => {
  switch (activity) {
    case 'hiking':
      return Hiking;
    case 'biking-mtn':
      return BikingMtn;
    case 'running':
      return Running;
    case 'biking-road':
      return BikingRoad;
  }
};

export type Chip = HeatmapActivityOption | HeatmapTimeRangeOption;

type OptionChipProps = {
  isSelected?: boolean;
  chip: Chip;
  onClick: (chip: Chip) => void;
  index: number;
  totalNumberOfChips: number;
};

const OptionChip = ({ isSelected, chip, onClick, index, totalNumberOfChips }: OptionChipProps) => {
  const handleClick = useCallback(() => onClick(chip), [chip, onClick]);

  return (
    <div
      className={classNames(styles.chip, {
        [styles.selected]: isSelected,
        [styles.fullWidth]: index === 0 && totalNumberOfChips % 2 === 1
      })}
      data-testid={`${chip.value}-${index}`}
    >
      <label className={styles.optionLabel}>
        <input
          className={styles.input}
          type="radio"
          name={chip.name}
          value={chip.value}
          onChange={handleClick}
          checked={isSelected}
          aria-label={chip.name}
        />
        {'icon' in chip && chip?.icon ? <IconRenderer icon={{ Component: getIcon(chip.icon) }} defaults={{}} /> : null}
        {chip.name}
      </label>
    </div>
  );
};

export default OptionChip;
